// ==========================
// Helper: Refresh cart items via Shopify section
// ==========================
function refreshCartItems() {
  fetch('/cart?section_id=drawer')
    .then(res => res.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newItems = tempDiv.querySelector('.cart__drawer-center');
      if (newItems) document.querySelector('.cart__drawer-center').innerHTML = newItems.innerHTML;
    })
    .catch(console.error);
}

// ==========================
// Open / Close Drawer
// ==========================
document.addEventListener('DOMContentLoaded', () => {
  const drawerWrapper = document.querySelector('#drawer ');
  const drawer = document.querySelector('.cart__drawer');
  const overlay = document.querySelector('.cart__drawer-overlay');
  const closeBtn = document.querySelector('.cart__drawer-close');

  function openDrawer() {
    drawer.classList.add('show');
    overlay.classList.add('show');
    document.body.classList.add('cv--show-cart__drawer');
    refreshCartItems();
    
    setTimeout(() => {
      setDrawerHeight();
    }, 1500);
  }

  function closeDrawer() {
    drawer.classList.remove('show');
    overlay.classList.remove('show');
    document.body.classList.remove('cv--show-cart__drawer');
  }

  // Open drawer
  document.querySelectorAll('.site-header__cart').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      openDrawer();
    });
  });

  // Close drawer buttons
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Close on Escape key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  function cartBubbleUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const bubble = document.querySelector('#CartCount');
        if (bubble) {
          bubble.setAttribute('data-header-cart-count', cart.item_count);
        }
      })
      .catch(console.error);
  }

  // ==========================
// Add to Cart
// ==========================
    document.addEventListener('click', function(e) {
    const addTocart = e.target.closest('.productitem--action-atc.add-to-cart');
    const ModalAddTocart = e.target.closest('.modal-inner .product-form--atc-button');
    const checkoutCartBtns = e.target.closest('#drawer .cart-drawer-checkout-button');
    if (!checkoutCartBtns){
      // e.preventDefault();
    }
    if(addTocart || ModalAddTocart)
      setTimeout(() => {
        openDrawer();
      }, 1000);
    });

  // ==========================
  // Remove Item
  // ==========================
  drawerWrapper.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.cart-item__remove-link');
    if (removeBtn) {
      e.preventDefault();
      const itemUrl = removeBtn.getAttribute('href');

      fetch(itemUrl)
        .then(res => res.text())
        .then(() => {
          refreshCartItems();
          cartBubbleUpdate();
        })
        .catch(console.error);
    }
  });

  // ==========================
  // Quantity + / - Buttons
  // ==========================

  function debounce(fn, delay) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }
  const updateCartDebounced = debounce(function(form) {
    const formData = new FormData(form);

    fetch('/cart/update', { method: 'POST', body: formData })
      .then(res => res.text())
      .then(() => {
        refreshCartItems();
        cartBubbleUpdate();
      })
      .catch(console.error);
  }, 700); // 700ms delay

  drawerWrapper.addEventListener('click', function(e) {
    const plusBtn = e.target.closest('.quantity-selector__button-wrapper--plus');
    const minusBtn = e.target.closest('.quantity-selector__button-wrapper--minus');

    if (plusBtn || minusBtn) {
      const input = plusBtn ? plusBtn.previousElementSibling : minusBtn.nextElementSibling;
      const form = input.closest('form');
      let quantity = parseInt(input.value, 10);

      if (plusBtn) quantity += 1;
      else if (minusBtn && quantity > 0) quantity -= 1;

      input.value = quantity;
      updateCartDebounced(form);
    }
  });

  

    // Drawer height on mobile 
    function getViewportHeight() {
      if (window.visualViewport) {
        return window.visualViewport.height - 20;
      }
      return window.innerHeight - 20;
    }

    function setDrawerHeight() {
      if (drawer){
        drawer.style.height = getViewportHeight() + 'px';
        // drawer.style.height = window.innerHeight + 'px';
      }
    }

    // Run on page load
    window.addEventListener('load', setDrawerHeight);

    // Run when screen size changes (resize, mobile address bar show/hide)
    window.addEventListener('resize', setDrawerHeight);

    // Extra safety for mobile orientation change
    window.addEventListener('orientationchange', setDrawerHeight);

});
